var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"sign-in-page"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-12 col-sm-4 offset-sm-4 align-self-center"},[_c('router-view')],1)])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }